export const text = {
  VISIT_SUMMARY: 'Visit summary',
  PATIENT_INFORMATION: 'Patient information',
  FULL_NAME: 'Full name: ',
  DOB: 'DOB (age/sex): ',
  PHONE_NUMBER: 'Phone number: ',
  EMAIL: 'Email: ',
  ADDRESS: 'Address: ',
  VISIT_INFORMATION: 'Visit information',
  DATE_TIME: 'Date/Time: ',
  PROVIDER: 'Provider: ',
  VISIT_TYPE: 'Visit type: ',
  VISIT_METHOD: 'Visit method: ',
  BOOKING_STATE: 'Booking state: ',
  PLEASE_REVIEW_CHANGES: 'Please review any changes made. Visits can only be rescheduled once.',
}
